"use client";
import Link from "next/link";
import { Button } from "@/components/ui/button";

export default function ErrorPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 via-white to-green-100 dark:from-zinc-900 dark:via-zinc-950 dark:to-zinc-900 px-4">
      <div className="w-full max-w-md bg-white/90 dark:bg-zinc-950/90 rounded-3xl shadow-2xl p-8 flex flex-col items-center border border-zinc-100 dark:border-zinc-800">
        <div className="text-6xl mb-4">😕</div>
        {/* Optional illustration if present */}
        {/* <Image
          src="/error-illustration.png"
          alt="Error occurred"
          width={220}
          height={160}
          className="mb-6"
        /> */}
        <h1 className="text-3xl font-bold mb-2 text-center text-green-700 dark:text-green-400">
          Oops! Something went wrong.
        </h1>
        <p className="text-base text-zinc-600 dark:text-zinc-300 mb-8 text-center max-w-xs">
          We couldn&apos;t process your request. Please try again, or return to
          the homepage.
        </p>
        <Button
          asChild
          size="lg"
          className="bg-green-600 hover:bg-green-700 w-full"
        >
          <Link href="/">Go to Homepage</Link>
        </Button>
      </div>
    </div>
  );
}
